module.exports = __webpack_public_path__ + "72e97ee0143e98b6518f35827a86b2fe.svg";